import React from 'react';
import { Alert } from 'react-bootstrap';

interface ErrorAlertProps {
    message: string;
    variant?: string; // Optional: Allow different alert styles (e.g., 'danger', 'warning')
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ message, variant = 'danger' }) => {
    return (
        <Alert variant={variant} dismissible className="my-3">
            <Alert.Heading as="h6">Error</Alert.Heading>
            <p className="mb-0">{message || 'An unexpected error occurred.'}</p>
        </Alert>
    );
};

export default ErrorAlert; 